module.exports = __webpack_public_path__ + "assets/img/baoguan.10df17c3.png";